<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2>Welcome to Phoenix Communicator</h2>
        <p>
          Phoenix Communicator – The premiere K-12 Communication System.
        </p>
        <hr>
      </div>
    </div>
    <div v-if="scoped_site_id !== 1 || sites.length === 1">
      <div class="row">
        <div class="col">
          <figure class="figure">
            <router-link :to="{ name: 'CalendarScheduler' }" class="nav-link">
              <img src="../assets/images/home_icons/scheduler.png" height="175" width="175" class="figure-img">
              <figcaption class="text-center">Scheduler</figcaption>
            </router-link>
          </figure>
        </div>
        <div class="col">
          <figure class="figure">
            <router-link :to="{ name: 'ZoneManager' }" class="nav-link">
              <img src="../assets/images/home_icons/zones.png" height="175" width="175" class="figure-img">
              <figcaption class="text-center">Zones</figcaption>
            </router-link>
          </figure>
        </div>
        <div class="col">
          <router-link :to="{ name: 'Devices' }" class="nav-link">
            <figure class="figure">
              <img src="../assets/images/home_icons/devices.png" height="175" width="175" class="figure-img">
              <figcaption class="text-center">Devices</figcaption>
            </figure>
          </router-link>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <router-link :to="{ name: 'SoundFilesIndex' }" class="nav-link">
            <figure class="figure">
              <img src="../assets/images/home_icons/sounds.png" height="175" width="175" class="figure-img">
              <figcaption class="text-center">Sounds</figcaption>
            </figure>
          </router-link>
        </div>
        <div class="col">
          <router-link :to="{ name: 'Notifications' }" class="nav-link">
            <figure class="figure">
              <img src="../assets/images/home_icons/announcements.png" height="175" width="175" class="figure-img">
              <figcaption class="text-center">Announcements</figcaption>
            </figure>
          </router-link>
        </div>
        <div class="col">
          <router-link :to="{ name: 'AdminDashboard' }" class="nav-link" v-if="[2,3,4].includes(logged_in_user.group_id)">
            <figure class="figure">
              <img src="../assets/images/home_icons/admin.png" height="175" width="175" class="figure-img">
              <figcaption class="text-center">Admin</figcaption>
            </figure>
          </router-link>
        </div>
      </div>
    </div>
    <div v-else>
      <div v-for="zone in filtered_zones" :key="zone.zone_id">
        <div class="row">
          <div class="col-12">
            <h4>{{ zone.name }}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-2 text-center" v-for="child in zone.zone_zones" :key="child.zone_zone_id" @click="changeScopedSiteId(child.child_zone.site.site_id)">
            <img :src="'./upload/images/site_logos/' + child.child_zone.site.site_id + '.png'" alt="Site logo" width="100" height="100"> <br>
            <p>{{ child.child_zone.site.name }} ({{ child.child_zone.site.extension_prefix }})</p>
          </div>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'home',
  computed: {
    ...mapGetters({
      is_authenticated: 'isAuthenticated',
      logged_in_user: 'loggedInUser',
      scoped_site_id: 'scopedSiteId',
      zones: 'allZones',
      sites: 'allSites'
    }),
    filtered_zones: function () {
      return this.zones.filter(zone => zone.site_id === this.scoped_site_id && zone.zone_type_id === 2)
    }
  },
  created () {
    this.$store.dispatch('getZones')
  },
  methods: {
    changeScopedSiteId (newScopedSiteId) {
      this.$store.dispatch('changeScopedSiteId', newScopedSiteId)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
